import firebase from 'firebase';
require('firebase/firestore');
const config = {
  apiKey: "AIzaSyBwUwqS0iefqbRvENrWx32o60iApalS7GM",
  authDomain: "lunch-school-app.firebaseapp.com",
  databaseURL: "https://lunch-school-app.firebaseio.com",
  projectId: "lunch-school-app",
  storageBucket: "lunch-school-app.appspot.com",
  messagingSenderId: "43325288915",
};
const fire = firebase.initializeApp(config);
const db = fire.firestore();
db.settings({timestampsInSnapshots: true});
export { fire, db }


// WEBPACK FOOTER //
// ./src/fire.js